import { render } from "./Dash-Inventory.vue?vue&type=template&id=30ff6a8f&scoped=true"
import script from "./Dash-Inventory.vue?vue&type=script&lang=js"
export * from "./Dash-Inventory.vue?vue&type=script&lang=js"

import "./Dash-Inventory.vue?vue&type=style&index=0&id=30ff6a8f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30ff6a8f"

export default script